import React, { useState } from 'react'
import {
    GridDropZone,
    GridItem
  } from "react-grid-dnd";
import reportbuilder from "../ReportBuilder.module.css";
import { useSelector, useDispatch } from 'react-redux'
import {Button} from "@mui/material"
import { setReportVal } from '../../../reduxStore/reducer';
import { Height } from '@mui/icons-material';

const DropValues = () => {
    const dispatch = useDispatch();
    const items = useSelector((state) => state.selectedDimensions.reportVal)
    console.log("items from drop values",items[0]);
      // console.log("selected items",newTopArr);
      const removeHandeler =(clickedObj)=>{
        console.log("clickedObj from drop values", clickedObj);
       //remove one obj from values bottom
        let newBottomArr = items[0].reportBottom.filter((item)=>{return item.id != clickedObj.id})
        console.log("newArr inside drop values",clickedObj,newBottomArr);
          let newTopArr = [...items[0].reportTop,clickedObj]
          console.log("newTopArr", newTopArr);
        
        dispatch(setReportVal([
          {
            // ...items,
            ["reportBottom"]:newBottomArr,
            ["reportTop"] : newTopArr
          }
        ]
          
        ))
       }
    return (
      // <GridContextProvider onChange={onChange}>
           <div className={reportbuilder.dropvalue} >
           <GridDropZone
            className="dropzone"
            id="reportBottom"
            boxesPerRow={1}
            rowHeight={40}
            style={{height:"25vh",borderRadius:"0%", overflowY:"scroll"}}      
          >
           {
            // console.log("items",items)
           items[0]?.reportBottom?.map(item => (
            <GridItem style={{zIndex:100, display:"flex", flexDirection:"column"}} key={item.name}>
              <div className="grid-item" >
                
                 <Button className="grid-item-content" sx={{bgcolor:"#e6ecff", color:"#000", fontSize:"11px"}} onClick={()=>removeHandeler(item)}>
                 <span style={{marginRight:"0.5rem"}}>-</span>{item.name}
                  </Button>
              </div>
            </GridItem>
          ))
           }
              {/* {items[0]?.right.map(item => (
              <GridItem key={item.name}>
                <div className="grid-item">
                  <div className="grid-item-content">
                    {item.name[0].toUpperCase()}
                  </div>
                </div>
              </GridItem>
            ))} */}
          </GridDropZone> 
  </div>
   
  // </GridContextProvider>
     
    )
  }
export default DropValues